import React from 'react';

const Hero = () => (
    <header className="hero">
        <div className="hero-content">
            <h2>Premium Quality Stone & Aggregates</h2>
            <p>Your trusted source for construction, landscaping, and industrial materials.</p>
            <a href="#products" className="cta-button">Explore Our Products</a>
        </div>
    </header>
);

export default Hero;